var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAccountM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.51 20.83a7.5 7.5 0 10-8.36-.23 13.09 13.09 0 00-9.1 11.32 1 1 0 002 .16 11 11 0 0121.9 0A1 1 0 0032 33a1 1 0 001-1.08 13.09 13.09 0 00-8.49-11.09zM15 14.5a5.5 5.5 0 115.5 5.5 5.51 5.51 0 01-5.5-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconAccountM;